import { ActionTree } from 'vuex';
import { AxiosResponse } from 'axios';
import HttpService from '@/plugins/http-service';
import EventBus from '@/plugins/event-bus';
import IRootState from '@/store/types/IRootState';
import IRequestState from './types/IRequestState';
import IRequestMeta from './types/IRequestMeta';
import IRequestForm from './types/IRequestForm';
import IRequestHeader from './types/IRequestHeader';

const actions: ActionTree<IRequestState, IRootState> = {
  async load(context) {
    try {
      const { data: {
        meta,
        header,
        form,
      } }: AxiosResponse<{
        meta: IRequestMeta,
        header: IRequestHeader,
        form: IRequestForm,
      }> = await HttpService.get(`/page/request.json`);

      context.commit('setMeta', meta);
      context.commit('setHeader', header);
      context.commit('setForm', form);

      return { meta, header, form };
    } catch (error) {
      return Promise.reject(error);
    }
  },

  submit(context, data) {
    EventBus.$emit('progress-delay', 3);
    EventBus.$emit('progress-start');

    return HttpService.post('/form/submit', data, {
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
      },
    }).then((response: any) => {
      return response.json();
    }).then((response: any) => {
      EventBus.$emit('progress-stop');
      EventBus.$emit('clear-request-form');
    }).catch(() => {
      EventBus.$emit('progress-stop');
    });
  },
};

export default actions;
